const COOKIE_DOMAIN = "electricshuffle.com";

// domain attribute is only valid when running on a electricshuffle.com (sub)domain, e.g. not on localhost
function getDomainAttribute(): string {
  return window.location.hostname.endsWith(COOKIE_DOMAIN) ? `; domain=${COOKIE_DOMAIN}` : "";
}

export function setCookie(name: string, value: string, days: number): void {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  const secureAttr = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/${getDomainAttribute()}; SameSite=Lax${secureAttr}`;
}

export function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

const STORY_OPTIN_COOKIE_NAME = "re_story_optin";
const STORY_OPTIN_COOKIE_DAYS = 45;
// a shared venue device is used by multiple friends joining the same game, so a repeat
// submission shortly after the first shouldn't clobber the original value - only a later,
// separate venue visit should/ 2 hours later
const STORY_OPTIN_SAME_VISIT_WINDOW_MS = 2 * 60 * 60 * 1000;

// stores value alongside the time it was set, so later submissions can tell whether they're
// still part of the same venue visit
export function setStoryOptInCookie(hasOptedIn: boolean): void {
  const existing = getCookie(STORY_OPTIN_COOKIE_NAME);
  if (existing) {
    const [, existingTimestamp] = existing.split(":");
    const age = Date.now() - Number(existingTimestamp);
    if (!Number.isNaN(age) && age < STORY_OPTIN_SAME_VISIT_WINDOW_MS) {
      return;
    }
  }
  setCookie(STORY_OPTIN_COOKIE_NAME, `${hasOptedIn}:${Date.now()}`, STORY_OPTIN_COOKIE_DAYS);
}

export function getStoryOptIn(): string | null {
  const existing = getCookie(STORY_OPTIN_COOKIE_NAME);
  return existing ? existing.split(":")[0] : null;
}

const PLAYER_COOKIE_NAME = "re_player";
const PLAYER_COOKIE_DAYS = 90;
// only the first player to join on a shared venue device should be stored, so a friend
// joining shortly after doesn't clobber it - only a later, separate visit (2 hours+) should
const PLAYER_SAME_VISIT_WINDOW_MS = 2 * 60 * 60 * 1000;

// stores the uid alongside the time it was set, so later joins can tell whether they're
// still part of the same venue visit
export function setPlayerCookie(playerUid: string): void {
  const existing = getCookie(PLAYER_COOKIE_NAME);
  if (existing) {
    const [, existingTimestamp] = existing.split(":");
    const age = Date.now() - Number(existingTimestamp);
    if (!Number.isNaN(age) && age < PLAYER_SAME_VISIT_WINDOW_MS) {
      return;
    }
  }
  setCookie(PLAYER_COOKIE_NAME, `${playerUid}:${Date.now()}`, PLAYER_COOKIE_DAYS);
}

export function getPlayerUid(): string | null {
  const existing = getCookie(PLAYER_COOKIE_NAME);
  return existing ? existing.split(":")[0] : null;
}
